export const LogType = {
  All: {
    value: 0,
    label: '全量日志',
    condition: null
  }
};
//# sourceMappingURL=base.js.map
